import React, { useContext } from 'react';
import { Users, HelpCircle, Shield, Scale } from 'lucide-react';
import { I18nContext } from '../../context/translations/TranslationsContext.context';

interface QuickActionsGridV2Props {
	onInviteFriend?: () => void;
	onFaq?: () => void;
	onSecurity?: () => void;
	onLegal?: () => void;
}

const QuickActionsGridV2: React.FC<QuickActionsGridV2Props> = ({
	onInviteFriend,
	onFaq,
	onSecurity,
	onLegal
}) => {
	const {
		state: { translate }
	} = useContext(I18nContext);

	const actions = [
		{
			icon: <Users className="w-6 h-6 text-primary" />,
			title: translate('individual.dashboard.quickActions.inviteFriend'),
			description: translate('individual.dashboard.quickActions.inviteFriendDesc'),
			onClick: onInviteFriend
		},
		{
			icon: <HelpCircle className="w-5 h-5 text-primary" />,
			title: translate('individual.dashboard.quickActions.faq'),
			description: translate('individual.dashboard.quickActions.faqDesc'),
			onClick: onFaq
		},
		{
			icon: <Shield className="w-5 h-5 text-primary" />,
			title: translate('individual.dashboard.quickActions.security'),
			description: translate('individual.dashboard.quickActions.securityDesc'),
			onClick: onSecurity
		},
		{
			icon: <Scale className="w-5 h-5 text-primary" />,
			title: translate('individual.dashboard.quickActions.legal'),
			description: translate('individual.dashboard.quickActions.legalDesc'),
			onClick: onLegal
		}
	];

	return (
		<div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
			{actions.map((action, idx) => (
				<button
					key={idx}
					className="bg-white border border-muted rounded-3xl p-6 text-left hover:shadow-md transition-shadow flex flex-col items-start"
					onClick={action.onClick}
				>
					<div
						className="bg-primary/10 rounded-2xl w-12 h-12 flex items-center justify-center mb-4"
						data-testid="quick-action-icon"
					>
						{action.icon}
					</div>
					<h3 className="text-base font-bold font-heading text-foreground leading-6">
						{action.title}
					</h3>
					<p className="text-xs text-muted-foreground mt-1 leading-4">{action.description}</p>
				</button>
			))}
		</div>
	);
};

export default QuickActionsGridV2;
